import * as React from "react";
import { observer, inject } from "mobx-react";

// import "./HorsesList.css";

export interface Props {}
export interface State {}

// @inject("HorseForSaleStore")
// @observer
export default class TotalCommisionsCollected extends React.Component<Props, State> {
    render() {
        return (
            <>
                <div className="card shadow-sm">
                    <div className="card-header py-2">Total commisssions collected</div>
                    <div className="card-body">Not available yet.</div>
                </div>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/reports/TotalCommisionsCollected.tsx